import { AxiosRequestConfig } from "axios";
import { getAuthToken } from "src/redux/services";
import { http } from "src/redux/services/http";

const requestInterceptor = (config: AxiosRequestConfig) => {
  const authToken = getAuthToken() as string;

  if (authToken && config.headers) config.headers.Authorization = authToken;

  return config as any;
};

const registerAuthInterceptor = () => {
  http.interceptors.request.use(requestInterceptor);
};

export default registerAuthInterceptor;
